import { portalPageSlugCheckService } from 'src/api/collection'
import { slugify } from 'src/pages/collection/portal-page/parts'

/**
 * The URL a custom portal page gets for a new name: the name as a slug, or
 * that slug with -2, -3… when it is taken. Keeps `currentSlug` when the name
 * gives no slug (e.g. only symbols) or no free one is found.
 */
export const slugForPageName = async (name, pageId, currentSlug) => {
  const base = slugify(name)
  if (!base) return currentSlug
  if (base === currentSlug) return currentSlug
  for (let n = 1; n <= 20; n += 1) {
    const candidate = n === 1 ? base : `${base}-${n}`
    if (candidate === currentSlug) return currentSlug
    try {
      const response = await portalPageSlugCheckService(candidate, pageId)
      if (response?.data?.available !== false) return candidate
    } catch (error) {
      return candidate
    }
  }
  return currentSlug
}

/**
 * The slug to save with a portal page's new name, wherever it is renamed
 * (Navigation's Change label, the editor's title): a custom page or the
 * catalog moves to the address the name gives; Home, My account and Sign in
 * keep theirs. The catalog's slug must always be sent: an empty one puts it
 * back at /catalog.
 */
export const slugForRename = async ({ type, id, slug }, name) => {
  if (type !== 'custom' && type !== 'catalog') return slug ?? null
  const currentSlug = slug || (type === 'catalog' ? 'catalog' : '')
  if (type === 'catalog' && slugify(name) === 'catalog') return 'catalog'
  return slugForPageName(name, id, currentSlug)
}
